import { sharedStaticDefaults } from './common';

export const accessGroupStaticDefaults = {
  defaultDraft: {
    name: 'Access group 1',
    schedule: 'Always (24/7)',
    selectedReaders: ['reader-main', 'reader-side'],
  },
  operatorAiFilledFields: ['name', 'schedule', 'selectedReaders'] as const,
  operatorAssistantHint: sharedStaticDefaults.operatorPartialPrefillHint,
  success: {
    groupName: 'Access group 1',
    summaryLine: 'Access group 1 · 3 doors · Always (24/7)',
    nextSteps: [
      { id: 'open', label: 'Open Access group 1' },
      { id: 'assign', label: 'Assign users to this group' },
      { id: 'add-another', label: 'Add another access group' },
      { id: 'edit', label: 'Edit doors or schedule' },
    ],
  },
  explainability:
    'Based on your site (First floor) and the readers you mentioned, I prepared an access group with three doors on an always schedule. You can change anything before approving.',
  assistantHint:
    'I’ll help you create a First floor access group, a set of rules that controls which doors open and when. Cards assigned to it will work on the doors you choose. You can fill the card below or send the details in one message, and I’ll draft it for you. Example: “Create Marketing group for lab reader 1, entrance reader 1, and server room on an always schedule.”',
} as const;
